import { cssRule } from 'typestyle';

cssRule('.tb-search-panel', {
    position: 'relative',
});

cssRule('.tb-search-box', {
    height: '23px',
});

cssRule('.tb-search-box .tb-text-box-border', {
    paddingLeft: '21px',
});

cssRule('.tb-search-button', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '21px',
    backgroundColor: 'transparent',
    border: 'none',
    textIndent: '-9999px',
    backgroundImage: 'url(img/magnifying_glass_small_normal.svg?1_0_9606_yabs0uv7t1h)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    cursor: 'pointer',
});

cssRule('.tb-search-button:hover', {
    backgroundImage: 'url(img/magnifying_glass_small_hover.svg?1_0_9606_yabs0uv7t1h)',
});

